import Vue from 'vue'
import App from './App.vue'
import router from "./router";

import './assets/main.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VuePrlx from 'vue-prlx'
import { VuePrlxDirective } from 'vue-prlx'
Vue.use(VuePrlx);

Vue.directive('prlx', VuePrlxDirective);

// import style
import './assets/animate.css'
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
import G from './plugins/global'
Vue.use(G);
router.afterEach(() => {
  window.scrollTo(0, 0)
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
